document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    if (e.target.closest(".oj-special-btn label")) {
        const triggers = document.querySelectorAll(".collapsible-trigger");

        triggers.forEach((trigger, index) => {
            if (trigger.classList.contains("is-open")) {
            trigger.click(); // fire click on that element
            console.log("Clicked index:", index);
            }
        });
        const target = document.querySelector("#know-diff-tab");
        if (target) {
            const offset = 100; // top space in px
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
            });
        }
      const btn = document.querySelector(".know-diff-tab-btn");
      if (btn) btn.click();
      e.preventDefault();
    }
    // $('.know-diff-tab-btn').click();
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("KnowVideoModal");
  const openBtn = document.querySelector(".open-know-video");
  const closeBtn = modal.querySelector(".close-know-video");
  console.log("run dummmy");
  // Open modal
  openBtn.addEventListener("click", function () {
  console.log("run dummmy 1");

    modal.classList.add("active");
    document.body.classList.add("modal-open");
    return false;
  });

  // Close modal on button
  closeBtn.addEventListener("click", function () {
    modal.classList.remove("active");
    document.body.classList.remove("modal-open");
  });

  // Close modal if clicking outside content
  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.classList.remove("active");
      document.body.classList.remove("modal-open");
    }
  });
});
document.addEventListener("DOMContentLoaded", function() {
  const copyButtons = document.querySelectorAll("[data-evt-copy]");

  copyButtons.forEach(button => {
    const tooltip = button.querySelector(".copy-tooltip");

    button.addEventListener("click", () => {
      const textToCopy = button.getAttribute("data-evt-copy");

      if (navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy);
      } else {
        // fallback
        const tempInput = document.createElement("input");
        document.body.appendChild(tempInput);
        tempInput.value = textToCopy;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
      }

      // Show tooltip
      tooltip.classList.add("show");

      // Hide after 1.5 sec
      setTimeout(() => {
        tooltip.classList.remove("show");
      }, 1500);
    });
  });
});